// ToC season boundaries + bucketing.
//
// FFTBG groups tournaments into "seasons", each ending in a Tournament of
// Champions. seasons.txt (on fftbattleground.com — a different origin, no CORS,
// so the browser can't read it) lists the tournament ID that STARTS each season,
// one per line. A tournament ID is a ms timestamp, so season N spans
// [SEASON_BOUNDARIES[N-1], SEASON_BOUNDARIES[N]). These line up 1:1 with the live
// API's `Season` field (verified to the ms against the founding champion's
// timestamp: API champion #1's defeat ~= SEASON_BOUNDARIES[0]).
//
// Small + append-only (a new number a few times a year), so it lives inline here
// as the single source of truth — imported by both the app and the backfill
// tools. Refresh after each new ToC opens a season:
//   node tools/fetchSeasons.mjs        (rewrites the array between the @seasons markers)

export const SEASON_BOUNDARIES = [
  // @seasons:start (generated by tools/fetchSeasons.mjs)
  1577633138990, // S1   2019-12-29
  1582396517081, // S2   2020-02-22
  1587230639860, // S3   2020-04-18
  1592673680707, // S4   2020-06-20
  1598721195449, // S5   2020-08-29
  1604772879703, // S6   2020-11-07
  1610216767654, // S7   2021-01-09
  1615659717512, // S8   2021-03-13
  1621706876023, // S9   2021-05-22
  1627755319614, // S10  2021-07-31
  1634408366432, // S11  2021-10-16
  1642880107661, // S12  2022-01-22
  1650738965219, // S13  2022-04-23
  1657996516400, // S14  2022-07-16
  1665859729710, // S15  2022-10-15
  1674328189525, // S16  2023-01-21
  1683397584477, // S17  2023-05-06
  1692469840654, // S18  2023-08-19
  1699729987022, // S19  2023-11-11
  1707593496317, // S20  2024-02-10
  1716057602089, // S21  2024-05-18
  1725129293438, // S22  2024-08-31
  1734205714347, // S23  2024-12-14
  1742063175423, // S24  2025-03-15
  1750530467294, // S25  2025-06-21
  1758997553148, // S26  2025-09-27
  1766950119136, // S27  2025-12-28
  1775932369711, // S28  2026-04-11
  1786299769004, // S29  2026-08-09
  // @seasons:end
];

export const SEASON_COUNT = SEASON_BOUNDARIES.length;

// 1-based season number for a tournament/reign id (ms timestamp). Ids before S1
// fold into Season 1 — the API counts the pre-feed founding reign there, so a
// reign that started before the feed opened still credits to S1.
export function seasonOf(id) {
  for (let n = SEASON_BOUNDARIES.length; n >= 1; n--) {
    if (id >= SEASON_BOUNDARIES[n - 1]) return n;
  }
  return 1;
}

// [startId, endId) for season n (1-based). The current (last) season runs to
// Infinity; an out-of-range n yields [undefined, …].
export function seasonRange(n) {
  return [SEASON_BOUNDARIES[n - 1], SEASON_BOUNDARIES[n] ?? Infinity];
}

// Start timestamp (ms) of season n (1-based), or undefined if out of range.
export function seasonStart(n) {
  return SEASON_BOUNDARIES[n - 1];
}
